export const enum Navigation {
    Landing = '/',
    // Authentication
    Login = '/login',
    Signup = '/signup',
    SignupNew = '/signup/new',
    SignupNewSuccess = '/signup/new/success',
    SignupFastTrackSuccess = '/signup/fast-track/success',
    SignupFastTrackInquirySuccess = '/signup/fast-track/inquiry/success',
    SignupActivateNew = '/signup/activate/new',
    SignupActivateFastTrack = '/signup/activate/fast-track',
    SignupActivateSuccess = '/signup/activate/success',
    PasswordForgot = '/password/forgot',
    PasswordForgotSuccess = '/password/forgot/success',
    PasswordReset = '/password/reset',
    PasswordResetSuccess = '/password/reset/success',
    Impersonate = '/impersonate',
    // Sales and Rental
    SalesProductList = '/sales/products',
    SalesProductListNew = '/sales/products/new',
    SalesProductListUsed = '/sales/products/used',
    SalesProductListSale = '/sales/products/sale',
    RentalProductList = '/rental/products',
    RentalProductListSanitary = '/rental/products/sanitary',
    RentalProductListStorage = '/rental/products/storage',
    RentalProductListOffice = '/rental/products/office',
    SalesProductDetail = '/sales/products/detail',
    RentalProductDetail = '/rental/products/detail',
    // Cart and Checkout
    SalesCart = '/sales/cart',
    RentalCart = '/rental/cart',
    SalesCheckout = '/sales/cart/checkout',
    RentalCheckout = '/rental/cart/checkout',
    SalesCheckoutSuccess = '/sales/cart/checkout/success',
    RentalCheckoutSuccess = '/rental/cart/checkout/success',
    // Account
    Users = '/account/users',
    Account = '/account',
    AccountSettings = '/account/settings',
    Employees = '/account/employees',
    NotFound = '/not-found',
    RentalNotFound = '/rental/products/not-found',
    SalesNotFound = '/sales/products/not-found',
    AccountNotFound = '/account/not-found',
    OrderList = '/account/orders',
    OrderDetail = '/accounts/orders/detail',
    OrderConfirmationList = 'accounts/order-confirmations',
    OrderConfirmationDetail = 'accounts/order-confirmations/detail',
    OfferList = '/account/offers',
    OfferChangeRequestHistory = '/account/offers/change-request-history',
    OfferDetail = '/account/offers/detail',
    OfferDetailCheckout = '/account/offers/detail/checkout',
    OfferDetailCheckoutSuccess = '/account/offers/detail/checkout/success',
    InvoiceList = '/account/invoices',
    Leads = '/account/leads',
    LeadDetails = '/account/leads/detail',
    Downloads = '/account/downloads',
    // Supplier
    DepotStock = '/suppliers/depot-stock',
    // Misc
    Changelog = '/changelog',
}

// copied from https://github.com/vuejs/router/blob/main/packages/router/src/history/common.ts as these types ar not exported
export enum NavigationType {
    pop = 'pop',
    push = 'push',
}
export enum NavigationDirection {
    back = 'back',
    forward = 'forward',
    unknown = '',
}
export interface NavigationInformation {
    type: NavigationType;
    direction: NavigationDirection;
    delta: number;
}
